export default "__VITE_ASSET__xen40uur__";